/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The physician to mark as default, or null to clear the default.
 * @export
 * @interface SetDefaultFacilityPhysicianRequestPhysicianId
 */
export interface SetDefaultFacilityPhysicianRequestPhysicianId {
}

/**
 * Check if a given object implements the SetDefaultFacilityPhysicianRequestPhysicianId interface.
 */
export function instanceOfSetDefaultFacilityPhysicianRequestPhysicianId(value: object): value is SetDefaultFacilityPhysicianRequestPhysicianId {
    return true;
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdFromJSON(json: any): SetDefaultFacilityPhysicianRequestPhysicianId {
    return SetDefaultFacilityPhysicianRequestPhysicianIdFromJSONTyped(json, false);
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetDefaultFacilityPhysicianRequestPhysicianId {
    return json;
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdToJSON(json: any): SetDefaultFacilityPhysicianRequestPhysicianId {
    return SetDefaultFacilityPhysicianRequestPhysicianIdToJSONTyped(json, false);
}

export function SetDefaultFacilityPhysicianRequestPhysicianIdToJSONTyped(value?: SetDefaultFacilityPhysicianRequestPhysicianId | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

